import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.188 8.688a2.16 2.16 0 0 0 2.187 2.187 2.176 2.176 0 0 0 2.188-2.187V8.25H7.187zM7.16 5.297h.027a.88.88 0 0 0 .93.055l.848-.493a.9.9 0 0 1 .41-.109.9.9 0 0 1 .383.11l.848.492c.3.164.656.136.957-.055V5.27h.027l.082-.082.41-.329c.082-.054.191-.109.273-.109h.082a.47.47 0 0 1 .438.438v3.5c0 1.94-1.586 3.5-3.5 3.5a3.49 3.49 0 0 1-3.5-3.5v-3.5a.45.45 0 0 1 .438-.438h.054c.11 0 .192.055.274.11l.437.327.082.083zm.684 7.766h3.062c2.516 0 4.594 2.078 4.594 4.593v.219c0 .492-.41.875-.875.875h-10.5a.864.864 0 0 1-.875-.875v-.219a4.604 4.604 0 0 1 4.594-4.593m7.219-1.313c-.766 0-1.45-.273-1.997-.71 0-.028.028-.056.028-.083.328-.52.547-1.148.629-1.832 0-.137.027-.273.027-.437V5.926a2.9 2.9 0 0 1 1.313-.301c1.667 0 3.062 1.395 3.062 3.063a3.075 3.075 0 0 1-3.062 3.062m1.066 7c.137-.246.246-.547.246-.875v-.219c0-1.64-.766-3.144-1.914-4.129.055 0 .11-.027.191-.027h1.668a4.446 4.446 0 0 1 4.43 4.43c0 .465-.383.82-.848.82z"
    }, null, -1)
  ]))]))
}
export default { render: render }